import axios from "axios";
import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import { SubscriptionsResponse } from "@appTypes/index";
import rollbar, { LogMetadata } from "@utils/rollbar";

const getSubscriptions = async (signal?: AbortSignal): Promise<ApiResponse<SubscriptionsResponse>> => {
  try {
    const response = await paymentGatewayApi.get<SubscriptionsResponse>(
      "/v1/billing/subscriptions",
      { signal, requireAuth: true }
    );
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { data: null, success: false, error: "AbortError" };
    }
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/billing/subscriptions", method: "GET" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error fetching subscriptions" };
  }
};

export default getSubscriptions;
